(function () {
  var DEBUG = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  // ── Config ──
  var MAX_PREVIEW_PANELS = 50;
  var MAX_PANEL_HEIGHT_PX = 160;
  var FALLBACK_PREVIEW_WIDTH = 300;
  var DEBOUNCE_MS = 400;
  var CART_DRAWER_DELAY_MS = 600;

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    var str = String(value);
    var length = str.length;
    var result = '';
    for (var i = 0; i < length; i++) {
      var ch = str.charAt(i);
      var code = str.charCodeAt(i);
      if (code === 0) { result += '\uFFFD'; continue; }
      if ((code >= 1 && code <= 31) || code === 127 ||
          (i === 0 && code >= 48 && code <= 57) ||
          (i === 1 && code >= 48 && code <= 57 && str.charCodeAt(0) === 45)) {
        result += '\\' + code.toString(16) + ' ';
        continue;
      }
      if (i === 0 && code === 45 && length === 1) { result += '\\' + ch; continue; }
      if (code >= 128 || code === 45 || code === 95 ||
          (code >= 48 && code <= 57) ||
          (code >= 65 && code <= 90) ||
          (code >= 97 && code <= 122)) {
        result += ch;
        continue;
      }
      result += '\\' + ch;
    }
    return result;
  }

  function toNumber(value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function parseNumbers(value) {
    if (!value) return [];
    var matches = String(value).match(/\d+(?:\.\d+)?/g);
    if (!matches) return [];
    return matches.map(function (v) {
      return Number(v);
    }).filter(function (v) {
      return Number.isFinite(v);
    });
  }

  function getOptionInput(root, optionName, productFormId) {
    var escapedName = optionName.replace(/"/g, '\\"');
    var escapedFormId = cssEscape(productFormId || '');
    var escapedRadioName = cssEscape(optionName);
    var select = root.querySelector('select[name="options[' + escapedName + ']"][form="' + escapedFormId + '"]');
    if (!select) {
      select = root.querySelector('select[name="options[' + escapedName + ']"]');
    }
    if (select) return select;
    var radios = root.querySelectorAll('input[type="radio"][name="' + escapedRadioName + '"][form="' + escapedFormId + '"]');
    if (!radios.length) {
      radios = root.querySelectorAll('input[type="radio"][name="' + escapedRadioName + '"]');
    }
    return radios.length ? Array.prototype.slice.call(radios) : null;
  }

  function setOptionValue(formRoot, optionName, value, productFormId) {
    var input = getOptionInput(formRoot, optionName, productFormId);
    if (!input) return false;

    if (Array.isArray(input)) {
      var matched = false;
      input.forEach(function (radio) {
        var shouldCheck = radio.value === value;
        radio.checked = shouldCheck;
        if (shouldCheck) {
          matched = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      return matched;
    }

    if (input.value !== value) {
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function readSelectedOptionValue(formRoot, optionName, productFormId) {
    var input = getOptionInput(formRoot, optionName, productFormId);
    if (!input) return null;

    if (Array.isArray(input)) {
      var selected = input.find(function (radio) {
        return radio.checked;
      });
      return selected ? selected.value : null;
    }

    return input.value;
  }

  function formatMoney(cents, moneyFormat, currencyCode) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function getVariantById(variants, id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function findMatchingVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      return variant.options.every(function (optionValue, index) {
        return optionValue === selectedOptions[index];
      });
    }) || null;
  }

  function parsePanelMeta(panelLabel) {
    var numbers = parseNumbers(panelLabel);
    if (!numbers.length) {
      return { widthIn: NaN, heightIn: NaN };
    }
    if (numbers.length === 1) {
      return { widthIn: NaN, heightIn: numbers[0] };
    }
    return { widthIn: numbers[0], heightIn: numbers[1] };
  }

  function initCalculator(root) {
    if (root.dataset.calculatorInitialized === 'true') return;
    root.dataset.calculatorInitialized = 'true';

    var payloadEl = root.querySelector('[data-calculator-payload]');
    if (!payloadEl) return;

    var payload;
    try {
      payload = JSON.parse(payloadEl.textContent);
    } catch (e) {
      if (DEBUG) console.error('Wallpaper Calculator: failed to parse product data', e);
      return;
    }
    var variants = Array.isArray(payload.variants) ? payload.variants : [];
    var optionNames = Array.isArray(payload.options) ? payload.options : [];
    if (!variants.length || !optionNames.length) return;

    var sectionId = root.dataset.sectionId;
    var sectionRoot = document.getElementById('MainProduct-' + sectionId) || root.closest('[data-section="' + sectionId + '"]') || root;
    var form = sectionRoot;
    var productFormId = root.dataset.productFormId;
    var addToCartForm = productFormId ? sectionRoot.querySelector('#' + cssEscape(productFormId)) || document.getElementById(productFormId) : null;
    if (!addToCartForm) {
      if (DEBUG) console.warn('Wallpaper Calculator: product form not found (id: ' + productFormId + ')');
      return;
    }

    var toggle = root.querySelector('.wallpaper-calculator__toggle');
    var content = root.querySelector('.wallpaper-calculator__content');
    var applyButton = root.querySelector('.wallpaper-calculator__apply');
    var widthInput = root.querySelector('[data-calculator-input="width"]');
    var heightInput = root.querySelector('[data-calculator-input="height"]');

    var panelOut = root.querySelector('[data-calculator-output="panel-size"]');
    var qtyOut = root.querySelector('[data-calculator-output="quantity"]');
    var unitOut = root.querySelector('[data-calculator-output="price-per-panel"]');
    var totalOut = root.querySelector('[data-calculator-output="total-price"]');
    var preview = root.querySelector('[data-calculator-preview]');
    var applyRecommendationBtn = root.querySelector('[data-calculator-apply-recommendation]');

    var cachedPreviewWidth = (preview && preview.offsetWidth) || FALLBACK_PREVIEW_WIDTH;
    function onResize() {
      if (preview) cachedPreviewWidth = preview.offsetWidth || FALLBACK_PREVIEW_WIDTH;
    }
    window.addEventListener('resize', onResize);
    root._wpcCleanup = function () {
      window.removeEventListener('resize', onResize);
    };

    var lastRecommendation = null;
    var wallpaperTypeOut = root.querySelector('[data-calculator-output="wallpaper-type"]');

    var unitBtns = root.querySelectorAll('.wallpaper-calculator__unit-btn');
    var unitLabels = root.querySelectorAll('.wallpaper-calculator__unit-label');
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        unitBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('active');
        btn.setAttribute('aria-checked', 'true');
        var label = btn.dataset.unit === 'cm' ? 'cm' : 'inches';
        unitLabels.forEach(function (el) { el.textContent = label; });
      });
    });

    var typeBtns;

    function bindTypeBtns() {
      typeBtns = root.querySelectorAll('.wallpaper-calculator__type-btn');
      typeBtns.forEach(function (btn) {
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', String(btn.classList.contains('active')));
        btn.addEventListener('click', function () {
          typeBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-checked', 'false'); });
          btn.classList.add('active');
          btn.setAttribute('aria-checked', 'true');
        });
      });
    }

    function getSelectedWallpaperType() {
      var active = root.querySelector('.wallpaper-calculator__type-btn.active');
      return active ? active.dataset.wallpaperType : 'Traditional';
    }

    var panelOptionName = root.dataset.panelSizeOptionName;
    var applicationOptionName = root.dataset.applicationOptionName;
    var panelIndex = optionNames.findIndex(function (name) {
      return name.toLowerCase() === String(panelOptionName || '').toLowerCase();
    });

    if (panelIndex < 0) {
      var err = document.createElement('p');
      err.className = 'wallpaper-calculator__error';
      err.textContent = 'Panel size option not found. Update the block setting to match your option name.';
      root.appendChild(err);
      return;
    }

    var panelValues = [];
    variants.forEach(function (variant) {
      var value = variant.options[panelIndex];
      if (value && panelValues.indexOf(value) < 0) panelValues.push(value);
    });

    panelValues.sort(function (a, b) {
      return parsePanelMeta(a).heightIn - parsePanelMeta(b).heightIn;
    });

    var appIndex = applicationOptionName ? optionNames.findIndex(function (name) {
      return name.toLowerCase() === String(applicationOptionName).toLowerCase();
    }) : -1;

    if (appIndex >= 0) {
      var appValues = [];
      variants.forEach(function (variant) {
        var val = variant.options[appIndex];
        if (val && appValues.indexOf(val) < 0) appValues.push(val);
      });

      var typeDescriptions = {
        'non pasted': 'Requires adhesive',
        'non-pasted': 'Requires adhesive',
        'traditional': 'Requires adhesive',
        'pre pasted': 'Water-activated',
        'pre-pasted': 'Water-activated',
        'prepasted': 'Water-activated',
        'peel & stick': 'Self-adhesive',
        'peel and stick': 'Self-adhesive',
        'commercial grade vinyl': 'Heavy-duty'
      };

      var typeContainer = root.querySelector('.wallpaper-calculator__type-options');
      if (typeContainer && appValues.length) {
        typeContainer.replaceChildren();
        appValues.forEach(function (val, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'wallpaper-calculator__type-btn' + (idx === 0 ? ' active' : '');
          btn.dataset.wallpaperType = val;
          var nameSpan = document.createElement('span');
          nameSpan.className = 'wallpaper-calculator__type-name';
          nameSpan.textContent = val;
          btn.appendChild(nameSpan);
          var desc = typeDescriptions[val.toLowerCase()];
          if (desc) {
            var descSpan = document.createElement('span');
            descSpan.className = 'wallpaper-calculator__type-desc';
            descSpan.textContent = desc;
            btn.appendChild(descSpan);
          }
          typeContainer.appendChild(btn);
        });

        bindTypeBtns();
      }
    }

    bindTypeBtns();

    var maxPanelMeta = parsePanelMeta(panelValues[panelValues.length - 1] || '');
    var maxHeightIn = Number.isFinite(maxPanelMeta.heightIn) ? maxPanelMeta.heightIn : 394;

    var heightWarning = document.createElement('p');
    heightWarning.className = 'wallpaper-calculator__warning hidden';
    var fieldsEl = root.querySelector('.wallpaper-calculator__fields');
    if (fieldsEl) fieldsEl.parentNode.insertBefore(heightWarning, fieldsEl.nextSibling);

    function getUnits() {
      var activeBtn = root.querySelector('.wallpaper-calculator__unit-btn.active');
      return activeBtn ? activeBtn.dataset.unit : 'in';
    }

    function normalizeLength(value) {
      var number = toNumber(value);
      if (!Number.isFinite(number) || number <= 0) return NaN;
      return getUnits() === 'cm' ? number / 2.54 : number;
    }

    function getCurrentSelections() {
      return optionNames.map(function (name) {
        return readSelectedOptionValue(form, name, productFormId);
      });
    }

    function resolvePanelSize(heightIn) {
      if (!panelValues.length || !Number.isFinite(heightIn)) return null;
      var firstHigher = panelValues.find(function (value) {
        return parsePanelMeta(value).heightIn >= heightIn;
      });
      return firstHigher || panelValues[panelValues.length - 1];
    }

    function getPanelWidth(selectedPanelSize) {
      var meta = parsePanelMeta(selectedPanelSize);
      if (Number.isFinite(meta.widthIn) && meta.widthIn > 0) return meta.widthIn;
      var currentSelection = readSelectedOptionValue(form, panelOptionName, productFormId);
      var currentMeta = parsePanelMeta(currentSelection);
      if (Number.isFinite(currentMeta.widthIn) && currentMeta.widthIn > 0) return currentMeta.widthIn;
      return 20;
    }


    function renderPreview(quantity, panelSize) {
      if (!preview) return;
      preview.replaceChildren();
      if (!quantity || !Number.isFinite(quantity)) return;

      if (quantity > MAX_PREVIEW_PANELS) {
        var msg = document.createElement('p');
        msg.className = 'wallpaper-calculator__preview-more';
        msg.textContent = quantity + ' panels needed \u2014 too many to preview.';
        preview.appendChild(msg);
        return;
      }

      var meta = parsePanelMeta(panelSize || '');
      var pw = (Number.isFinite(meta.widthIn) && meta.widthIn > 0) ? meta.widthIn : 20;
      var ph = (Number.isFinite(meta.heightIn) && meta.heightIn > 0) ? meta.heightIn : 53;

      var containerWidth = cachedPreviewWidth || FALLBACK_PREVIEW_WIDTH;
      var panelWidthPx = containerWidth / quantity;
      var panelHeightPx = Math.min(panelWidthPx * (ph / pw), MAX_PANEL_HEIGHT_PX);

      var frag = document.createDocumentFragment();
      for (var i = 0; i < quantity; i += 1) {
        var panel = document.createElement('div');
        var isOdd = i % 2 === 0;
        panel.className = 'wallpaper-calculator__preview-panel'
          + (isOdd ? ' wallpaper-calculator__preview-panel--odd' : ' wallpaper-calculator__preview-panel--even');
        panel.style.height = panelHeightPx + 'px';

        var label = document.createElement('span');
        label.className = 'wallpaper-calculator__preview-label';
        label.textContent = String(i + 1);
        panel.appendChild(label);

        frag.appendChild(panel);
      }
      preview.appendChild(frag);
    }

    function updateSummary(variant, quantity, panelSize) {
      panelOut.textContent = panelSize || '-';
      qtyOut.textContent = Number.isFinite(quantity) ? String(quantity) : '-';

      var unitPrice = variant ? variant.price : 0;
      unitOut.textContent = variant ? formatMoney(unitPrice, root.dataset.moneyFormat, root.dataset.currencyCode) : '-';
      totalOut.textContent = variant ? formatMoney(unitPrice * quantity, root.dataset.moneyFormat, root.dataset.currencyCode) : '-';
      renderPreview(quantity || 0, panelSize);
    }

    function calculateAndApply() {
      var widthIn = normalizeLength(widthInput.value);
      var heightIn = normalizeLength(heightInput.value);
      if (!Number.isFinite(widthIn) || !Number.isFinite(heightIn)) return;

      if (heightIn > maxHeightIn) {
        heightIn = maxHeightIn;
        var displayMax = getUnits() === 'cm' ? Math.round(maxHeightIn * 2.54) + ' cm' : maxHeightIn + '"';
        heightInput.value = getUnits() === 'cm' ? Math.round(maxHeightIn * 2.54) : maxHeightIn;
        heightWarning.textContent = 'Maximum available height is ' + displayMax + '.';
        heightWarning.classList.remove('hidden');
      } else {
        heightWarning.classList.add('hidden');
      }

      var panelSize = resolvePanelSize(heightIn);
      if (!panelSize) return;

      var panelWidthIn = getPanelWidth(panelSize);
      if (!Number.isFinite(panelWidthIn) || panelWidthIn <= 0) return;

      var quantity = Math.max(1, Math.ceil(widthIn / panelWidthIn));

      var selectedOptions = getCurrentSelections();
      selectedOptions[panelIndex] = panelSize;

      var chosenType = getSelectedWallpaperType();
      if (applicationOptionName && appIndex >= 0) {
        selectedOptions[appIndex] = chosenType;
      }
      if (wallpaperTypeOut) wallpaperTypeOut.textContent = chosenType;

      var matchedVariant = findMatchingVariant(variants, selectedOptions);
      updateSummary(matchedVariant, quantity, panelSize);

      var resultsEl = root.querySelector('.wallpaper-calculator__results');
      if (resultsEl) resultsEl.classList.remove('hidden');
      if (preview) preview.classList.remove('hidden');

      lastRecommendation = { panelSize: panelSize, quantity: quantity, selectedOptions: selectedOptions, variant: matchedVariant };
      if (applyRecommendationBtn) {
        applyRecommendationBtn.classList.remove('hidden');
        applyRecommendationBtn.classList.remove('wallpaper-calculator__apply-recommendation--done');
        applyRecommendationBtn.textContent = 'Add Recommended Panels to Cart';
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (content) content.classList.toggle('hidden', isOpen);
      });
    }

    var calcBusy = false;
    if (applyButton) {
      applyButton.addEventListener('click', function () {
        if (calcBusy) return;
        calcBusy = true;
        applyButton.disabled = true;
        calculateAndApply();
        setTimeout(function () { calcBusy = false; applyButton.disabled = false; }, DEBOUNCE_MS);
      });
    }

    if (applyRecommendationBtn) {
      applyRecommendationBtn.addEventListener('click', function () {
        if (!lastRecommendation) return;

        var matchedVariant = lastRecommendation.variant;
        if (!matchedVariant) {
          applyRecommendationBtn.textContent = 'Variant not found \u2013 try again';
          if (DEBUG) console.error('Wallpaper Calculator \u2013 no variant matched. Options:', lastRecommendation.selectedOptions);
          return;
        }

        applyRecommendationBtn.disabled = true;
        applyRecommendationBtn.textContent = 'Adding\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: matchedVariant.id,
              quantity: lastRecommendation.quantity
            }],
            sections: ['cart-drawer', 'cart-icon-bubble']
          })
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function (parsedState) {
          applyRecommendationBtn.classList.add('wallpaper-calculator__apply-recommendation--done');
          applyRecommendationBtn.textContent = 'Added to Cart \u2713';
          applyRecommendationBtn.disabled = false;

          root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'wallpaper-calculator' } }));
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wallpaper-calculator' });
          }

          var cartDrawerEl = document.querySelector('cart-drawer');
          if (cartDrawerEl) {
            cartDrawerEl.classList.remove('is-empty');
            if (parsedState.sections && typeof cartDrawerEl.renderContents === 'function') {
              parsedState.id = matchedVariant.id;
              cartDrawerEl.renderContents(parsedState);
            } else {
              setTimeout(function () {
                if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
              }, CART_DRAWER_DELAY_MS);
            }
          }
        })
        .catch(function (err) {
          if (DEBUG) console.error('Wallpaper Calculator – add to cart error:', err);
          applyRecommendationBtn.textContent = 'Error – try again';
          applyRecommendationBtn.disabled = false;
        });
      });
    }

  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wallpaper-calculator[data-product-form-id]').forEach(initCalculator);
  });

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.wallpaper-calculator[data-product-form-id]').forEach(initCalculator);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.wallpaper-calculator[data-product-form-id]').forEach(function (root) {
      if (typeof root._wpcCleanup === 'function') {
        root._wpcCleanup();
        delete root._wpcCleanup;
      }
      delete root.dataset.calculatorInitialized;
    });
  });
})();
